"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$nameInline = void 0;
// import * as std from "../../../law/std";
const controls_1 = require("../../../node/el/controls");
const factory_1 = __importDefault(require("../factory"));
exports.$nameInline = factory_1.default
    .withName("nameInline")
    .sequence(s => s
    .and(r => r
    .zeroOrOne(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Text)
        && /以下(?:単に)?$/.test(item.text())) {
        return item;
    }
    else {
        return null;
    }
})), "following")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.____PointerRanges)) {
        return item;
    }
    else {
        return null;
    }
}))
    .andOmit(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Text)
        && /^において(?:単に)?$/.test(item.text())) {
        return item;
    }
    else {
        return null;
    }
})))), "pointerRanges")
    .andOmit(r => r
    .assert(({ following, pointerRanges }) => following || pointerRanges))
    .and(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Parentheses)
        && item.attr.type === "square"
        && item.content.children.every(c => c instanceof controls_1.__Text)) {
        return item;
    }
    else {
        return null;
    }
}), "nameSquareParentheses")
    .andOmit(r => r
    .zeroOrOne(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Text)
        && /^という。/.test(item.text())) {
        return item;
    }
    else {
        return null;
    }
})))
    .action(({ following, pointerRanges, nameSquareParentheses }) => {
    const value = {
        following: Boolean(following),
        pointerRanges,
        nameSquareParentheses,
    };
    return { value, errors: [] };
}));
exports.default = exports.$nameInline;
//# sourceMappingURL=$nameInline.js.map